import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { ISanitizer } from '../../../commonInfra/utils/Sanitize';
import { ISpaceItemDetailInfo } from '../../../ts/models/ISpaceItemDetailInfo';
import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';
import { ItemDescription } from '../Header/HeaderItemDescription';
import { OwnerMetadata } from '../Header/HeaderMetadataRow';
import { ActionsMenuIcon, DetailButtonIcon, FavoriteToggleWithCountsIcon } from '../Header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '../Header/SpaceHeader';

export interface ProjectSpaceHeaderProps extends SiteUrlsProps {
  readonly item: ISpaceItemDetailInfo<'project'>;
  readonly openDetail: () => void;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
  readonly sanitizer: ISanitizer;
  readonly selectedContentItemsCount: number;
}

export function ProjectSpaceHeader(props: ProjectSpaceHeaderProps): JSX.Element {
  const actionsMenuDisabled = props.selectedContentItemsCount > 0;
  const actionsMenuButtonTitle = actionsMenuDisabled ? Messages.projectActionsMenuDisabled() : null;

  return <ConnectedSpaceHeader
      item={props.item}
      nameRowIcons={
        <React.Fragment>
          { FavoriteToggleWithCountsIcon({
            item: props.item,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          }) }
          { DetailButtonIcon(props.item, props.openDetail) }
          { ActionsMenuIcon(props.item, actionsMenuDisabled, actionsMenuButtonTitle) }
        </React.Fragment>
      }
      metadataRow={ OwnerMetadata(props.item.owner, props.urls) }
      descriptionElement={ ItemDescription(props.item, props.openDetail, props.sanitizer) }
  />;
}
